import { Component, createRef } from "react";

import DataTable from "components/DigiHapi/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Material Dashboard 3 PRO React components
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import BookingCard from "examples/Cards/BookingCard";

// DigiHapi components
import Activity from "components/DigiHapi/Activity";
import ConfirmDialog from "components/DigiHapi/ConfirmDialog";
import MDWizard from "components/DigiHapi/MDWizard";
import Notification from "components/DigiHapi/Notification";
import PagePagination from "components/DigiHapi/PagePagination";

import defaultImage from "assets/img/image_placeholder.jpg";

import { FaRegNewspaper, FaHandHoldingHeart } from "react-icons/fa";
import { RiHeartsFill } from "react-icons/ri";

import LinesEllipsis from "react-lines-ellipsis";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
	fetchGetTemplates,
	fetchAddTemplate,
	fetchGetTemplateDetails,
	fetchUpdateTemplate,
	fetchDeleteTemplate,
	fetchCloneTemplate
} from "actions/template";
import { fetchGetEquipments } from "actions/equipment";
import { fetchGetPictosUri } from "actions/index";

import Step1 from "./Step1";
import Step2 from "./Step2";
import Step2_Activities from "./Step2_Activities";
import Step3 from "./Step3";
import Step3_Activities from "./Step3_Activities";
import Step4 from "./Step4";

import {
	RESET_TEMPLATE,
	SET_TEMPLATE_CATEGORY,
	SET_TEMPLATE_NEW_CATEGORY,
	SET_TEMPLATE_TYPE,
	ROLE_WEBMASTER,
	SET_TEMPLATE_SYSTEM
} from "actions/types.js";

class TemplateWizard extends Component {
	fetchAddTemplate = () => {
		const {
			fetchAddTemplate,
			categoryId,
			name,
			files,
			picto,
			description,
			postDescription,
			gooddealPostDescription,
			gooddealDescription,
			url,
			lang,
			dateId,
			timeId,
			equipmentId,
			acceptNotif,
			type,
			system,
			choices,
			community,
			usedByGooddeals
		} = this.props;

		fetchAddTemplate({
			categoryId,
			name,
			files,
			picto,
			description,
			postDescription,
			gooddealPostDescription,
			gooddealDescription,
			url,
			lang,
			dateId,
			timeId,
			equipmentId,
			acceptNotif,
			type,
			system,
			choices,
			communityId: community._id,
			usedByGooddeals
		});
	};

	fetchUpdateTemplate = () => {
		const {
			fetchUpdateTemplate,
			_id,
			categoryId,
			community,
			newCategoryId,
			name,
			files,
			description,
			postDescription,
			gooddealPostDescription,
			gooddealDescription,
			url,
			lang,
			dateId,
			timeId,
			equipmentId,
			acceptNotif,
			photoUri,
			picto,
			type,
			system,
			choices,
			usedByGooddeals
		} = this.props;

		fetchUpdateTemplate({
			_id,
			categoryId,
			communityId: community._id,
			newCategoryId,
			name,
			files,
			description,
			postDescription,
			gooddealPostDescription,
			gooddealDescription,
			url,
			lang,
			dateId,
			timeId,
			equipmentId,
			acceptNotif,
			photoUri,
			picto,
			type,
			system,
			choices,
			usedByGooddeals
		});
	};

	render() {
		const { update, isFetching, onClose, type, label } = this.props;
		return (
			<MDWizard
				onClose={onClose}
				isFetching={isFetching}
				validate
				steps={[
					{
						stepName: "Illustration",
						stepComponent: Step1,
						stepId: "picture"
					},
					{
						stepName: "Français",
						stepComponent: type === "Template" ? Step2 : Step2_Activities,
						stepId: "french"
					},
					{
						stepName: "Anglais",
						stepComponent: type === "Template" ? Step3 : Step3_Activities,
						stepId: "english"
					},
					{
						stepName: "Valeurs par défaut",
						stepComponent: Step4,
						stepId: "default"
					}
				]}
				title={update ? `Mise à jour d'${label}` : `Ajout d'${label}`}
				finishButtonClick={
					update ? this.fetchUpdateTemplate : this.fetchAddTemplate
				}
			/>
		);
	}
}

class Templates extends Component {
	state = {
		br: false,
		isFetching: false,
		color: "info",
		message: null,
		wizard: null,
		templateToDelete: null,
		data: [],
		sizePerPage: 3,
		page: 0,
		totalPages: 0,
		totalDocs: 0,
		templates: {},
		modeTable: false
	};

	constructor(props) {
		super(props);
		this.tableRef = createRef();
		this.wizardRef = createRef();
	}

	componentDidMount() {
		const {
			fetchGetPictosUri,
			fetchGetEquipments,
			fetchGetTemplates,
			type,
			community,
			pictos
		} = this.props;
		if (!pictos) {
			fetchGetPictosUri();
		}
		fetchGetEquipments(community._id);
		fetchGetTemplates(type, community._id);
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			fetchGetTemplates,
			type,
			snackErrorMsg,
			snackInfoMsg,
			newWizard,
			templates,
			community
		} = this.props;

		if (snackErrorMsg && prevProps.snackErrorMsg !== snackErrorMsg) {
			this.autoCloseMessage();
		}

		if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
			this.setState({
				wizard: null
			});
			fetchGetTemplates(type, community._id);
			this.autoCloseMessage();
		}

		if (
			Object.keys(templates).length > 0 &&
			Object.keys(prevProps.templates).length === 0
		) {
			this.changeCurrentPage(1);
		}

		if (newWizard && prevProps.newWizard !== newWizard) {
			this.addWizard(newWizard === "update");
		}
	}

	hideAlert = () => {
		this.setState({
			br: false
		});
	};

	autoCloseMessage = () => {
		const { snackErrorMsg, snackInfoMsg } = this.props;

		this.setState({
			br: true,
			message: snackInfoMsg ? snackInfoMsg : snackErrorMsg,
			color: snackInfoMsg ? "info" : "danger"
		});

		if (snackInfoMsg) {
			setTimeout(this.hideAlert, 5000);
		}
	};

	onClose = () => {
		this.setState({
			wizard: null
		});
		this.props.dispatch({
			type: RESET_TEMPLATE
		});
	};

	addWizard = (update = true) => {
		const { dispatch, type, label } = this.props;
		dispatch({
			type: SET_TEMPLATE_TYPE,
			payload: type
		});
		this.setState({
			wizard: (
				// wrap the React component in a standard DOM element and assign a ref to that
				// to scroll correctly
				<Grid
					item
					xs={12}
					ref={elt => {
						this.wizardRef = elt;
					}}
				>
					<ConnectedTemplateWizard
						update={update}
						onClose={this.onClose}
						type={type}
						label={label}
					/>
				</Grid>
			)
		});
	};

	addSystemWizard = () => {
		this.props.dispatch({
			type: SET_TEMPLATE_SYSTEM,
			payload: true
		});
		this.addWizard(false);
	};

	editTemplate = ({ categoryId, _id }) => {
		const { fetchGetTemplateDetails, dispatch, community } = this.props;
		fetchGetTemplateDetails(_id, community._id);
		dispatch({
			type: SET_TEMPLATE_CATEGORY,
			categoryId
		});
		dispatch({
			type: SET_TEMPLATE_NEW_CATEGORY,
			categoryId
		});
	};

	deleteTemplate = (categoryId, id) => {
		this.props.fetchDeleteTemplate(categoryId, id);
	};

	cloneTemplate = ({ categoryId, _id }) => {
		const { fetchCloneTemplate, community } = this.props;
		fetchCloneTemplate(categoryId, _id, community._id);
	};

	// Actions available on a template, depending on its system flag and the user role
	getActions = template => {
		const { user } = this.props;
		const { system, unused = false } = template;

		const actions = [];
		if (system) {
			if (unused) {
				actions.push({
					color: "success",
					icon: "content_copy",
					tooltip: "Dupliquer",
					onClick: this.cloneTemplate
				});
			}
			if (user.role === ROLE_WEBMASTER) {
				actions.push({
					color: "info",
					icon: "edit",
					tooltip: "Modifier",
					onClick: this.editTemplate
				});
				actions.push({
					color: "error",
					icon: "delete",
					tooltip: "Supprimer",
					onClick: this.delete
				});
			}
		} else {
			actions.push({
				color: "info",
				icon: "edit",
				tooltip: "Modifier",
				onClick: this.editTemplate
			});
			actions.push({
				color: "error",
				icon: "delete",
				tooltip: "Supprimer",
				onClick: this.delete
			});
		}
		return actions;
	};

	renderActions = (template, variant = "text") =>
		this.getActions(template).map(action => (
			<Tooltip key={action.tooltip} title={action.tooltip} placement="bottom">
				<span>
					<MDButton
						variant={variant}
						color={action.color}
						size="small"
						iconOnly
						circular={variant !== "text"}
						disabled={!!this.state.wizard}
						onClick={() => action.onClick(template)}
						sx={{ mx: 0.25 }}
					>
						<Icon>{action.icon}</Icon>
					</MDButton>
				</span>
			</Tooltip>
		));

	get2Chars = param => {
		return ("" + param).length === 1 ? "0" + param : param;
	};

	formatDate = d => {
		const date = new Date(d);
		return `${this.get2Chars(date.getDate())}/${this.get2Chars(
			date.getMonth() + 1
		)}/${date.getFullYear()} ${this.get2Chars(
			date.getHours()
		)}:${this.get2Chars(date.getMinutes())}`;
	};

	getTemplates = () => {
		const { templates } = this.props;

		const result = Object.values(templates).map(
			({ _id, dateUpdated, name, category, categoryId, system, unused }) => {
				return {
					_id,
					date: dateUpdated,
					name,
					category,
					actions: (
						<MDBox display="flex" justifyContent="flex-end">
							{this.renderActions(
								{
									_id,
									name,
									category,
									categoryId,
									system,
									unused
								},
								"gradient"
							)}
						</MDBox>
					)
				};
			}
		);
		return result;
	};

	delete = template => {
		this.setState({ templateToDelete: template });
	};

	renderTemplates = () => {
		const { templates, type, equipments, pictos } = this.props;
		const { data, page, totalDocs, sizePerPage, wizard } = this.state;
		const components = [];

		const indexBegin = page === 0 ? 0 : (page - 1) * sizePerPage;
		const indexEnd =
			page * sizePerPage > totalDocs ? totalDocs : page * sizePerPage;
		// eslint-disable-next-line
		for (let index = indexBegin; index < indexEnd; index++) {
			const obj = data[index];
			const template = templates[obj._original._id];
			if (template) {
				const equipmentName =
					template.equipmentId && equipments?.[template.equipmentId]
						? equipments[template.equipmentId].name
						: "";
				components.push(
					<Grid item key={template._id} xs={12} md={4}>
						<MDBox pt={3} height="100%">
							<BookingCard
								image={
									type === "Template" ? template.photoUri || defaultImage : ""
								}
								icon={
									type === "Template" ? null : (
										<MDBox
											component="img"
											src={pictos ? pictos[template.picto] : ""}
											alt={`${template.picto} made by Freepik from www.flaticon.com`}
											width="4rem"
											height="4rem"
											sx={{ objectFit: "contain" }}
										/>
									)
								}
								title={template.name}
								description={
									<MDBox minHeight="60px" sx={{ whiteSpace: "pre-wrap" }}>
										<LinesEllipsis
											text={template?.description || ""}
											maxLine={3}
											trimRight
											basedOn="letters"
										/>
									</MDBox>
								}
								price={
									template.system ? (
										<MDBadge
											badgeContent="Système"
											color="info"
											size="xs"
											container
										/>
									) : null
								}
								location={
									<Tooltip title="Lieu" placement="bottom">
										<MDBox display="flex" alignItems="center" color="success">
											<Icon color="inherit" sx={{ m: 0.5 }}>
												place
											</Icon>
											<MDTypography
												variant="button"
												fontWeight="light"
												color="text"
											>
												{equipmentName}
											</MDTypography>
										</MDBox>
									</Tooltip>
								}
								action={<MDBox>{this.renderActions(template)}</MDBox>}
								disableHover={!!wizard}
							/>
						</MDBox>
					</Grid>
				);
			}
		}
		return components;
	};

	changeCurrentPage = page => {
		this.tableRef &&
			this.tableRef.current &&
			this.tableRef.current.setState({ page: page - 1 }, () =>
				this.tableRef.current.fireFetchData()
			);
	};

	renderAddButtons = toggleLabel => {
		const { label, user } = this.props;
		const { modeTable, wizard } = this.state;
		return (
			<MDBox display="flex" flexWrap="wrap" justifyContent="flex-end" gap={1}>
				<MDButton
					variant="outlined"
					color="secondary"
					onClick={() => this.setState({ modeTable: !modeTable })}
					disabled={!!wizard}
				>
					<Icon>{modeTable ? "view_module" : "table_rows"}</Icon>
					&nbsp;{toggleLabel}
				</MDButton>
				{user.role === ROLE_WEBMASTER && (
					<MDButton
						variant="gradient"
						color="info"
						onClick={this.addSystemWizard}
						disabled={!!wizard}
					>
						<Icon>add</Icon>
						&nbsp;{`Ajout d'${label} système`}
					</MDButton>
				)}
				<MDButton
					variant="gradient"
					color="primary"
					onClick={() => this.addWizard(false)}
					disabled={!!wizard}
				>
					<Icon>add</Icon>
					&nbsp;{`Ajout d'${label}`}
				</MDButton>
			</MDBox>
		);
	};

	render() {
		const {
			color,
			message,
			page,
			totalPages,
			modeTable,
			wizard,
			templateToDelete
		} = this.state;
		const { isFetchingList, type, title, isFetchingEquipments } = this.props;

		return isFetchingEquipments ? (
			<Activity />
		) : (
			<Grid container spacing={3}>
				{!modeTable && (
					<>
						{this.renderTemplates()}
						{!wizard && (
							<Grid item xs={12}>
								<MDBox
									display="flex"
									flexWrap="wrap"
									justifyContent="space-between"
									alignItems="center"
									gap={2}
								>
									<PagePagination
										currentPage={page}
										totalPages={totalPages}
										changeCurrentPage={this.changeCurrentPage}
									/>
									<MDBox ml="auto">{this.renderAddButtons("Tableau")}</MDBox>
								</MDBox>
							</Grid>
						)}
					</>
				)}
				{/* The table stays mounted: it also sorts and paginates the cards */}
				<Grid item xs={12} sx={{ display: modeTable ? "block" : "none" }}>
					<Card>
						<MDBox
							mx={2}
							mt={-3}
							py={2}
							px={2}
							variant="gradient"
							bgColor="primary"
							borderRadius="lg"
							coloredShadow="primary"
							display="flex"
							alignItems="center"
							color="white"
						>
							{type === "Activity" ? (
								<RiHeartsFill size={24} />
							) : type === "Proposal" ? (
								<FaHandHoldingHeart size={24} />
							) : (
								<FaRegNewspaper size={24} />
							)}
							<MDTypography variant="h6" color="white" ml={1.5}>
								{title}
							</MDTypography>
						</MDBox>
						<MDBox p={2}>
							<DataTable
								ref={this.tableRef}
								data={this.getTemplates()}
								filterable
								columns={[
									{
										Header: "Date",
										accessor: "date",
										sortable: true,
										filterable: false,
										Cell: props => this.formatDate(props.value)
									},
									{
										Header: "Nom",
										accessor: "name",
										sortable: true,
										filterable: false
									},
									{
										Header: "Catégorie",
										accessor: "category",
										sortable: true,
										filterable: false
									},
									{
										Header: "Actions",
										accessor: "actions",
										sortable: false,
										filterable: false
									}
								]}
								defaultSorted={[
									{
										id: "date",
										desc: true
									}
								]}
								loading={isFetchingList}
								onFetchData={(state, instance) => {
									this.setState({
										page: state.page + 1,
										totalPages: state.pages,
										totalDocs: state.data.length,
										sizePerPage: state.pageSize,
										data: state.sortedData
									});
								}}
								defaultPageSize={6}
								pageSizeOptions={[3, 6, 9, 18, 36, 72]}
								showPaginationTop
								showPaginationBottom={false}
								previousText="Précédent"
								nextText="Suivant"
								rowsText="Lignes"
								noDataText={
									type === "Activity"
										? "Aucuns instants partage"
										: type === "Proposal"
										? "Aucuns besoins"
										: "Aucuns modèles"
								}
								ofText="sur"
								loadingText="Chargement..."
							/>
						</MDBox>
						<MDBox p={2}>{this.renderAddButtons("Fiches")}</MDBox>
					</Card>
				</Grid>
				{wizard}
				<ConfirmDialog
					open={!!templateToDelete}
					message={`Êtes-vous sûr de vouloir supprimer ${
						type === "Activity" ? "l'activité" : "le modèle"
					} ?`}
					confirmText="Supprimer"
					onCancel={() => this.setState({ templateToDelete: null })}
					onConfirm={() => {
						this.deleteTemplate(
							templateToDelete.categoryId,
							templateToDelete._id
						);
						this.setState({ templateToDelete: null });
					}}
				/>
				<Notification
					color={color}
					message={message}
					open={this.state.br}
					onClose={this.hideAlert}
				/>
			</Grid>
		);
	}
}

class TemplatesPage extends Templates {
	static defaultProps = {
		type: "Template",
		label: "un modèle",
		title: "Modèles"
	};
}

class ActivitiesPage extends Templates {
	static defaultProps = {
		type: "Activity",
		label: "un instant partage",
		title: "Instants partage"
	};
}

class ProposalsPage extends Templates {
	static defaultProps = {
		type: "Proposal",
		label: "un besoin",
		title: "Besoins"
	};
}

const mapStateToProps = state => {
	const {
		isFetchingList,
		isFetching,
		templates,
		_id,
		categoryId,
		newCategoryId,
		name,
		description,
		postDescription,
		gooddealPostDescription,
		gooddealDescription,
		files,
		lang,
		dateId,
		timeId,
		equipmentId,
		acceptNotif,
		snackInfoMsg,
		snackErrorMsg,
		newWizard,
		photoUri,
		picto,
		system,
		choices,
		usedByGooddeals
	} = state.templateReducer;
	const { pictos } = state.uploadReducer;
	const { community } = state.entitiesReducer;
	const { user } = state.profileReducer;
	const { equipments, isFetchingList: isFetchingEquipments } =
		state.equipmentReducer;
	return {
		isFetchingList,
		isFetching,
		templates,
		_id,
		categoryId,
		newCategoryId,
		name,
		description,
		postDescription,
		gooddealPostDescription,
		gooddealDescription,
		files,
		lang,
		dateId,
		timeId,
		equipmentId,
		acceptNotif,
		snackInfoMsg,
		snackErrorMsg,
		newWizard,
		photoUri,
		picto,
		user,
		system,
		choices,
		equipments,
		isFetchingEquipments,
		community,
		usedByGooddeals,
		pictos
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetEquipments,
			fetchGetTemplates,
			fetchAddTemplate,
			fetchGetTemplateDetails,
			fetchUpdateTemplate,
			fetchDeleteTemplate,
			fetchCloneTemplate,
			fetchGetPictosUri
		},
		dispatch
	);
	return { ...actions, dispatch };
};

const ConnectedTemplateWizard = connect(
	mapStateToProps,
	mapDispatchToProps
)(TemplateWizard);

export default {
	TemplatesPage: connect(mapStateToProps, mapDispatchToProps)(TemplatesPage),
	ActivitiesPage: connect(mapStateToProps, mapDispatchToProps)(ActivitiesPage),
	ProposalsPage: connect(mapStateToProps, mapDispatchToProps)(ProposalsPage),
	TemplateWizard: ConnectedTemplateWizard
};
